import type { ReactNode } from 'react';
import type { FilterType } from '../query/filter';
import type { CellChangeContext, CellContext, CellEditor } from './cell';

export interface TableColumn<T> {
    id?: string;
    field?: string;
    header?: string;
    type?: string;

    value?: (row: T) => unknown;
    render?: (ctx: CellContext<T>) => ReactNode;
    labels?: Record<string, string>;

    width?: number;
    minWidth?: number;

    sortable?: boolean;
    hidden?: boolean;
    rowDrag?: boolean;
    align?: 'left' | 'center' | 'right';

    filter?: false | FilterType;
    filterOptions?: { value: string; label: string }[];

    sortKey?: string;
    filterKey?: string;

    editable?: boolean;
    editor?: CellEditor<T>;
    onCellChange?: (ctx: CellChangeContext<T>) => void;
}

export interface TableColumnGroup<T> {
    header: string;
    id?: string;
    collapsible?: boolean;
    columns: TableColumn<T>[];
}

export type ColumnDef<T> = TableColumn<T> | TableColumnGroup<T>;

export interface ResolvedColumn<T> extends TableColumn<T> {
    id: string;
    header: string;
    groupHeader?: string;
    groupId?: string;
    canSort: boolean;
    canFilter: boolean;
    getValue: (row: T) => unknown;
}

export function isColumnGroup<T>(
    def: ColumnDef<T>,
): def is TableColumnGroup<T> {
    return 'columns' in def && Array.isArray(def.columns);
}
